const VIEWPORT_PADDING_PX = 16;

const remToPx = (rem: number) =>
  rem * parseFloat(getComputedStyle(document.documentElement).fontSize);

const getFitSideOffset = (
  anchor: Element | null | undefined,
  contentWidthRem: number,
  sideOffset = 0
) => {
  if (!anchor) {
    return sideOffset;
  }

  const { right } = anchor.getBoundingClientRect();
  const overflow =
    right +
    sideOffset +
    remToPx(contentWidthRem) +
    VIEWPORT_PADDING_PX -
    window.innerWidth;

  return overflow > 0 ? Math.floor(sideOffset - overflow) : sideOffset;
};

export { getFitSideOffset };
